import {useDispatch} from 'react-redux';

import {useQuery} from '@apollo/react-hooks';

import type {GetPersistedListParams as GetPersistedListParamsQuery} from 'nutshell-graphql-types';

import {EntityList} from '../../entity-list';

import GET_PERSISTED_QUERY_PARAMS from './get-persisted-query-params.graphql';

const ACCOUNTS_SETTING = 'entity_list_accounts_persisted_url';
const CONTACTS_SETTING = 'entity_list_contacts_persisted_url';
const LEADS_SETTING = 'entity_list_leads_persisted_url';

// Loads the last URL for people/company/lead lists stored in settings
// for the current user.
// This powers Nutshell 'remembering' your last filter/sort/etc
// on each list page even after logging out/back in
export function useGetPersistedQueryParams() {
    const dispatch = useDispatch();

    const {data} = useQuery<
        GetPersistedListParamsQuery,
        {
            accountsSetting: string;
            contactsSetting: string;
            leadsSetting: string;
        }
    >(GET_PERSISTED_QUERY_PARAMS, {
        variables: {
            accountsSetting: ACCOUNTS_SETTING,
            contactsSetting: CONTACTS_SETTING,
            leadsSetting: LEADS_SETTING,
        },
        onCompleted: () => {
            dispatch(EntityList.loadPersistedParams(data));
        },
    });
}
